export default "__VITE_ASSET__d5dd64e2__";